<template>
  <div class="l-content-inner">
    <div class="c-head">
      <h1 class="head-title">배합문의</h1>
      <BreadCrumb :breadcrumbs="getBreadcrumbItems" />
    </div>

    <div class="l-content">
      <!-- D: 조색배합 페이지 -->
      <div class="p-mising-wrap">
        <div class="l-white-box">
          <!-- D: c-tab-panel과 c-tab-panel-wrap은 세트임 -->
          <!-- D: border가 없는경우 type-non-border 추가 -->
          <div class="c-tab-panel-wrap type-non-border has-non-gap">
            <!-- tab content: tab1 -->
            <div class="tab-panel" role="tabpanel" aria-labelledby="tab1-1">
              <div class="mixing-inquiry-wrap">
                <form action="form-wrap">
                  <!-- D: table write -->
                  <div class="c-board-write">
                    <div class="tr">
                      <div class="th">
                        <!-- D: PC 전용 -->
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span>
                        </span>
                        제품명
                        <!-- // D: PC 전용 -->
                      </div>
                      <div class="td">
                        <div class="c-filter-box type-non-line">
                          <div class="c-check-field">
                            <div class="c-radio">
                              <input
                                type="radio"
                                id="raido1"
                                name="raidogroup"
                                v-model="data.colorCombin.pntSeCd"
                                value="WATER"
                                @click="
                                  searchCmd('ptnSeCdChk', { type: 'WATER' })
                                "
                                checked
                              />
                              <label for="raido1">수성</label>
                            </div>
                            <div class="c-radio">
                              <input
                                type="radio"
                                id="raido2"
                                name="raidogroup"
                                v-model="data.colorCombin.pntSeCd"
                                value="OIL"
                                @click="
                                  searchCmd('ptnSeCdChk', { type: 'OIL' })
                                "
                              />
                              <label for="raido2">유성</label>
                            </div>
                          </div>
                          <!-- D: PC 전용 -->
                          <div
                            :class="
                              data.vali.v01
                                ? 'c-select only-pc'
                                : 'c-select only-pc is-danger'
                            "
                          >
                            <select
                              v-model="data.colorCombin.chcPrdctSn"
                              @change="searchCmd('chkSelect', {})"
                            >
                              <option value="">선택</option>
                              <option
                                v-for="(item, idx) in data.selectBox.code01"
                                :key="idx"
                                :value="item.chcPrdctSn"
                              >
                                {{ item.prdctNm }}
                              </option>
                            </select>
                          </div>
                          <!-- // D: PC 전용 -->
                        </div>
                      </div>
                    </div>
                    <!-- MO 전용 -->
                    <div class="tr only-mo">
                      <div class="th">
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span> </span
                        >제품선택
                      </div>
                      <div class="td">
                        <div
                          :class="
                            data.vali.v01 ? 'c-select' : 'c-select is-danger'
                          "
                        >
                          <select
                            v-model="data.colorCombin.chcPrdctSn"
                            @change="searchCmd('chkSelect', {})"
                          >
                            <option value="">선택</option>
                            <option
                              v-for="(item, idx) in data.selectBox.code01"
                              :key="idx"
                              :value="item.chcPrdctSn"
                            >
                              {{ item.prdctNm }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!-- // MO 전용 -->
                    <div class="tr">
                      <div class="th">
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span> </span
                        >색상명
                      </div>
                      <div class="td">
                        <div
                          :class="
                            data.vali.v02
                              ? 'c-form-field'
                              : 'c-form-field is-danger'
                          "
                        >
                          <label class="c-input-group">
                            <input
                              type="text"
                              title="색상명 입력"
                              placeholder="색상명 입력"
                              v-model="data.colorCombin.colorNm"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="tr">
                      <div class="th">
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span> </span
                        >컬러북
                      </div>
                      <div class="td">
                        <div
                          :class="
                            data.vali.v03
                              ? 'c-form-field'
                              : 'c-form-field is-danger'
                          "
                        >
                        <div
                          :class="
                            data.vali.v06 ? 'c-select' : 'c-select is-danger'
                          "
                        >
                        <select v-model="data.colorCombin.colorBookCom"
                                @change="searchCmd('colorbookSelect', {})">
                          <option value="null">브랜드 선택</option>
                          <option
                            v-for="(item, idx) in data.selectBox.code06"
                            :key="idx"
                            :value="item.company"
                          >
                            {{ item.company }}
                          </option>
                        </select>
                        </div>
                        <div
                          :class="
                            data.vali.v07 ? 'c-select' : 'c-select is-danger'
                          "
                          id="selectColorbookNm"
                        >
                        <select v-model="data.colorCombin.colorBookNm">
                          <option value="null">컬러북 선택</option>
                          <option
                            v-for="(item, idx) in data.selectBox.code07"
                            :key="idx"
                            :value="item.colorbookNm"
                          >
                            {{ item.colorbookNm }}
                          </option>
                        </select>
                        </div>
                          <label class="c-input-group" 
                          id="inputColorbookNm" style="display: none;">
                            <input
                              type="text"
                              title="컬러북 입력"
                              placeholder="컬러북 입력"
                              v-model="data.colorCombin.colorBookNm"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="tr">
                      <div class="th">
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span> </span
                        >광택
                      </div>
                      <div class="td">
                        <div
                          :class="
                            data.vali.v04 ? 'c-select' : 'c-select is-danger'
                          "
                        >
                          <select
                            v-model="data.colorCombin.combnCrcolnShineTypeCd"
                          >
                            <option value="null">광택 선택</option>
                            <option
                              v-for="(item, idx) in data.selectBox.code02"
                              :key="idx"
                              :value="item.combnCrcolnShineTypeCd"
                            >
                              {{ item.shineSeNm }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="th has-mo-line">
                        <span class="c-required-star">
                          *<span class="sr-only">필수</span> </span
                        >규격
                      </div>
                      <div class="td">
                        <div
                          :class="
                            data.vali.v05 ? 'c-select' : 'c-select is-danger'
                          "
                        >
                          <select v-model="data.colorCombin.spcfctCd">
                            <option value="null">규격 선택</option>
                            <option
                              v-for="(item, idx) in data.selectBox.code03"
                              :key="idx"
                              :value="item.spcfctCd"
                            >
                              {{ item.spcfctNm }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!-- D: MOC 전용 -->
                    <div class="c-required-text only-mo">
                      <p>
                        <span class="c-required-star">*</span>는 필수 입력
                        사항입니다.
                      </p>
                    </div>
                    <!-- // D: MO 전용 -->
                    <div class="tr last">
                      <div class="th">문의내용</div>
                      <div class="td">
                        <div class="c-textarea-area">
                          <label for="user-message" class="sr-only"
                            >문의내용 신청란</label
                          >
                          <textarea
                            id="user-message"
                            placeholder="문의내용을 입력해 주세요.(3,000자 이내)"
                            v-model="data.colorCombin.qstnCn"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- D: PC 전용 -->
                  <div class="c-required-text only-pc">
                    <p>
                      <span class="c-required-star">*</span>는 필수 입력
                      사항입니다.
                    </p>
                  </div>
                  <!-- // D: PC 전용 -->
                </form>

                <div
                  class="c-btn-area has-fixed-visible is-fixed"
                  data-bottom-fixed
                >
                  <button
                    type="button"
                    class="c-button type-secondary"
                    @click="btnCmd('reset')"
                    style="--btn-width: 280px"
                  >
                    <span>초기화</span>
                  </button>
                  <button
                    type="submit"
                    class="c-button type-primary"
                    @click="btnCmd('insert')"
                    style="--btn-width: 280px"
                  >
                    <span>문의하기</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 조색관련 문의 -->
          <div class="c-customer-footer">
            <div class="section">
              <strong class="subject">칼라런트팀에 조색관련 문의하기</strong>
              <div class="tel-group">
                <p class="text">조색문의</p>
                <p class="tel">
                  <a href="tel:031-467-6389">031-467-6389</a>
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section">
              <div class="tel-group">
                <p class="text">고객문의</p>
                <p class="tel">
                  <a href="tel:080-944-7777">080-944-7777</a>
                </p>
              </div>
              <ul class="inquiry-time">
                <li>평일 - 09:00~18:00(일,공휴일 휴무)</li>
                <li>점심시간 - 12:00~13:00</li>
              </ul>
            </div>
            <div class="section">
              <a class="btn-tel" @click="btnCmd('remoteSupport', {})">
                <i class="c-icon icon-tel size-xmedium"></i>
                <span class="text">원격지원</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <QuickMenu />
  </div>
</template>

<script setup name="colorCombinmixedInq">
import { onMounted, reactive, inject, watch, computed } from "vue";

import QuickMenu from "@/components/paintpro/quickMenu/quickMenu.vue";
import BreadCrumb from "@/components/paintpro/base/breadCrumb.vue";

import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

import { api } from "@/plugins/api";
import { useRouter } from "vue-router";

const router = useRouter();
const url = inject("url_prefix");

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    token: "",
    isLogin: false,
    basketCount: 0,
    userLoginInfo: {},
    breadcrumbItems: [],
  },
  selectBox: {
    code01: [],
    code02: [],
    code03: [],
    code04: [],
    code05: [],
    code06: [],
    code07: [],
  },
  popup: {
    message: null,
    visible: false,
  },
  prod: null,
  colorCombin: {
    pntSeCd: null, //수성,유성
    chcPrdctSn: null, //선택제품 일련 번호
    combnCrcolnShineTypeCd: null, //광택
    spcfctCd: null, //규격
    qstnCn: null, //문의내용
    colorNm: null, //색상명
    colorBookNm: null, //컬러북명
    colorBookCom: null, //컬러북회사
  },
  init: {
    pntSeCd: "WATER", //수성,유성
    chcPrdctSn: "", //선택제품 일련 번호
    combnCrcolnShineTypeCd: null, //광택
    spcfctCd: null, //규격
    qstnCn: null, //문의내용
    colorNm: null, //색상명
    colorBookNm: null, //컬러북명
    colorBookCom: null,
  },
  vali: {
    v01: true,
    v02: true,
    v03: true,
    v04: true,
    v05: true,
    v06: true,
    v07: true,
  },
});

const getBreadcrumbItems = computed(() => {
  let list = [
    { name: "조색배합", path: "/paintpro/colorCombinList" },
    { name: "조색배합문의", path: "" },
  ];
  return list;
});

watch(
  () => store.useBasketCountStore().basketCount,
  (newValue) => {
    data.page.basketCount = newValue;
  }
);

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInitData();
});

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];
  const res = await cmApi.getPageInitData(mparm);

  const { resultCode } = res;
  if (resultCode !== 200) {
    //alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  data.page.token = cmUtil.getLocalStorage("token");
  data.page.isLogin = store.useAuthStore()?.user ? true : false;
  data.page.userLoginInfo = store.useAuthStore()?.user;

  data.colorCombin = data.init;
  searchCmd("ptnSeCdChk", { type: "WATER" });
   colorbookList();
}


async function colorbookList(){
      const res = await api.post(`${url}/colorCombin/selectColorbookCompany`, {});

    data.selectBox.code06 = res.data;
}

// /**********************
//  * 조회 모음
//  *********************/
async function searchCmd(cmd = "", params = {}) {
  //data.colorCombin.loading = true;

  //수성, 유성 > 제품 selectBoxList
  if (cmd === "ptnSeCdChk") {
    data.colorCombin.chcPrdctSn = "";
    const res = await api.post(`${url}/colorCombin/selectBox01`, {
      pntSeCd: params.type == null ? null : params.type,
      prdctSeCd: null,
    });

    data.selectBox.code01 = res.data;
    searchCmd("chkSelect");
  }
  // 광택,규격 selectBoxList
  else if (cmd === "chkSelect") {
    const selItem = data.selectBox.code01.find(
      (item) => item.chcPrdctSn == data.colorCombin.chcPrdctSn
    );
    // 광택
    const res1 = await api.post(`${url}/colorCombin/selectBox02`, {
      chcPrdctSn: selItem?.chcPrdctSn,
    });

    //규격
    const res2 = await api.post(`${url}/colorCombin/selectBox03`, {
      pntSn: selItem?.pntSn,
    });

    data.selectBox.code02 = res1.data;
    data.selectBox.code03 = res2.data;
  }
  // 컬러북 selectBoxList
  else if (cmd === "colorbookSelect") {

    if(data.colorCombin.colorBookCom != "기타(수기입력)"){
      document.getElementById("inputColorbookNm").style.display = "none";
      document.getElementById("selectColorbookNm").style.display = "block";
      const res3 = await api.post(`${url}/colorCombin/selectColorbookProd`, {
        company : data.colorCombin.colorBookCom,
      });
      data.selectBox.code07 = res3.data; 
    }else{
      document.getElementById("inputColorbookNm").style.display = "block";
      document.getElementById("selectColorbookNm").style.display = "none";
    }
  }
  data.colorCombin.combnCrcolnShineTypeCd = null;
  data.colorCombin.spcfctCd = null;

  // data.colorCombin.loading = false;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "") {
  // 문의하기
  if (cmd === "insert") {
    let flag = await validationCheck(data.colorCombin);

    if (flag == true) {
      const res = await api.post(`${url}/colorCombin/insertCombinmixedInq`, {
        ...data.colorCombin,
        qstnCn:
          data.colorCombin.qstnCn != null
            ? data.colorCombin.qstnCn.replaceAll("\n", "<br/>")
            : null,
        agencySn: data.page.userLoginInfo.agencySn,
        chcZempNo:
          data.page.userLoginInfo.empList[
            store.useEventBusStore().salesPersonIndex
          ]?.kunn2,
      });

      if (res.resultCode == 200) {
        await cmUtil.alert("문의가 등록되었습니다.");
        await moveToCombinInqTab();
      } else {
        await cmUtil.alert("문의가 등록되지 않았습니다.");
        return;
      }
    }
  }
  //초기화
  else if (cmd === "reset") {
    data.colorCombin = { ...data.init };
    data.selectBox.code02 = [];
    data.selectBox.code03 = [];
    data.selectBox.code07 = [];
    document.getElementById("inputColorbookNm").style.display = "none";
    document.getElementById("selectColorbookNm").style.display = "block";
    await searchCmd("ptnSeCdChk", { type: "WATER" });
  }
  // 원격지원
  else if (cmd == "remoteSupport") {
    const _url = "http://ezh.kr/noroo1/";
    window.open(_url, "_blank");
  }
}

// 유효성 체크
async function validationCheck(param) {
  if (
    param.chcPrdctSn == null ||
    param.chcPrdctSn == "" ||
    param.combnCrcolnShineTypeCd == null ||
    param.combnCrcolnShineTypeCd == "null" ||
    param.spcfctCd == null ||
    param.spcfctCd == "null" ||
    param.colorNm == null ||
    param.colorNm == "" ||
    param.colorBookNm == null ||
    param.colorBookNm == ""
  ) {
    if (param.chcPrdctSn == null || param.chcPrdctSn == "") {
      data.vali.v01 = false;
    } else {
      data.vali.v01 = true;
    }

    if (param.colorNm == null || param.colorNm == "") {
      data.vali.v02 = false;
    } else {
      data.vali.v02 = true;
    }

    if (param.colorBookNm == null || param.colorBookNm == "") {
      data.vali.v03 = false;
    } else {
      data.vali.v03 = true;
    }
    if (
      param.combnCrcolnShineTypeCd == null ||
      param.combnCrcolnShineTypeCd == "null"
    ) {
      data.vali.v04 = false;
    } else {
      data.vali.v04 = true;
    }
    if (param.spcfctCd == null || param.spcfctCd == "null") {
      data.vali.v05 = false;
    } else {
      data.vali.v05 = true;
    }
    cmUtil.alert("필수 입력 사항을 확인해 주세요.");
    return false;
  } else {
    data.vali.v01 = true;
    data.vali.v02 = true;
    data.vali.v03 = true;
    data.vali.v04 = true;
    data.vali.v05 = true;
    return true;
  }
}

/**********************
 * 조색배합문의 탭으로 이동
 *********************/
async function moveToCombinInqTab() {
  router.push({
    name: "/paintpro/colorCombinList",
  });
}
</script>
